import { useContext } from 'react';

import {
    Box,
    alpha,
    // Stack,
    lighten,
    // Divider,
    IconButton,
    // Tooltip,
    styled,
    useTheme
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
// import MenuIcon from '@mui/icons-material/Menu';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';

import HeaderUserbox from './usuario';

const HeaderWrapper = styled(Box)(
    ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
    const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
    const theme = useTheme();

    return (
        <HeaderWrapper
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
                boxShadow:
                    theme.palette.mode === 'dark'
                        ? `0 1px 0 ${alpha(
                            lighten(theme.colors.primary.main, 0.7),
                            0.15
                        )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
                        : `0px 2px 8px -3px ${alpha(
                            theme.colors.alpha.black[100],
                            0.2
                        )}, 0px 5px 22px -4px ${alpha(
                            theme.colors.alpha.black[100],
                            0.1
                        )}`
            }}
        >
            {/* Botón de menú en móvil */}
            <Box sx={{ display: { xs: 'inline-flex', lg: 'none' } }}>
                <IconButton color="inherit" onClick={toggleSidebar}>
                    {sidebarToggle ? <CloseTwoToneIcon /> : <MenuTwoToneIcon />}
                </IconButton>
            </Box>

            {/* Centro vacío o título */}
            <Box sx={{ flexGrow: 1, textAlign: 'center', display: { xs: 'none', sm: 'block' } }}>
                {/* <Typography variant="h6">Título opcional</Typography> */}
            </Box>

            {/* Usuario / Salir */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    minWidth: 0
                }}
            >
                <HeaderUserbox
                    sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: { xs: 150, sm: 200 }
                    }}
                />
            </Box>
        </HeaderWrapper>
    );
}
export default Header;